import React from 'react'

// Fetch from constants
export const OtpHeader = () => {
  return (
    <div>
        <header>
      <div className="head">
        <img
          src="https://assets.pharmeasy.in/web-assets/dist/fca22bc9.png"
          alt="logo"
        />
      </div>
      <div className="headright">
        <img
          src="https://assets.pharmeasy.in/web-assets/dist/1fe1322a.svg"
          alt="logo2"
        />
      </div>
    </header>
    </div>
  )
}
